import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProfileEffects } from './state/effects/profile.effects';
import * as fromUsers from './state/reducers';

@NgModule({
  imports: [StoreModule.forFeature(fromUsers.userProfileFeatureKey, fromUsers.userProfileReducers), EffectsModule.forFeature([ProfileEffects])]
})
export class ProfileModule {}
